import { createReducer, on } from '@ngrx/store';
import { ReqManagerGetTypes } from '../../shared/enums';
import { GetRequestManagerActions } from '../actions';
import { ResponseReqManagerGet, RequestManagerGet } from '../../shared/interfaces/getRequestManager.interface';

export interface ReqManagerGetState {
    response: ResponseReqManagerGet;
    request: RequestManagerGet;
    error: any;
}

export const ReqManagerGetInitialState: ReqManagerGetState = {
    response: null,
    request: null,
    error: null
};

const _reqManagerGetReducer = createReducer(
    ReqManagerGetInitialState,

    on(GetRequestManagerActions.getReqManagerGet, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(GetRequestManagerActions.getReqManagerGetSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(GetRequestManagerActions.getReqManagerGetError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(GetRequestManagerActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function reqManagerGetReducer(state, action) {
    if (action.type === ReqManagerGetTypes.REQUEST_MANAGER_GET) {
        state = undefined;
    }
    return _reqManagerGetReducer(state, action);
}
